import { cleanNumberFormatter } from "../../../gridFormatters";

export const databaseServerTrends = [
    	{
		"field": "status",
		"headerName": "Status",
	},
	{
		"field": "blocks",
		"headerName": "Blocks",
    cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
	},
	{
		"field": "Used",
		"headerName": "Used",
    cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
	},
	{
		"field": "free",
		"headerName": "Free",
    cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
	},
	{
		"field": "allocated",
		"headerName": "Allocated",
    cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
	},
	{
		"field": "bytes",
		"headerName": "Bytes",
    cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
	},
	{
		"field": "max_bytes",
		"headerName": "Max Bytes",
    cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",

	},
	{
		"field": "user_bytes",
		"headerName": "User (GiB)",
    cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
	},
	{
		"field": "user_blocks",
		"headerName": "User Blocks",
    cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
		hide: true,
	},
	{
		"field": "user_bytes",
		"headerName": "User Bytes",
    cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
		hide: true,
	},
]